<app-message
    [successMessage]="false"
    [messageTitle]="'messages.invalid-token.title' | translate"
    [message]="'messages.invalid-token.description' | translate"
>
</app-message>
